import { useState, useEffect, useRef } from 'react';
import { InfiniteScroll, Loading } from 'antd-mobile';
import Apis from '@/api';
import Error from '@/components/Error';
import { errorActions } from '@/reducers/Error';
import { useDispatch } from 'react-redux';
import LoadingHdl from '@/components/Loading';
import './index.scss';
const SignInFragment = () => {
  const dispatch = useDispatch();
  const pageSize = 10; //每页的条数
  const [currPage, setCurrPage] = useState<number>(1); //当前页
  const [data, setData] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [fragmentAccumulate, setFragmentAccumulate] = useState<any>(null);
  const loadingRef = useRef<any>(); //loading
  /**
   * @description: 查询碎片积累量
   */
  const getFragmentAccumulate = async () => {
    try {
      loadingRef.current.open();
      const res = await Apis.signIn.queryFragmentAccumulate();
      setFragmentAccumulate(res);
    } finally {
      loadingRef.current.close();
    }
  };
  /**
   * @description: 加载下一页
   */
  const loadMore = async () => {
    const res: any = await Apis.signIn.queryFragmentDetail({
      pageSize,
      currPage,
    });
    const resLen = res ? res.length : 0;
    resLen >= pageSize && setCurrPage(currPage + 1) && setHasMore(true); //可加载下一页
    resLen < pageSize && setHasMore(false); //加载完成
    res && setData([...data, ...res]);
  };
  /**
   * @description: 自定义loadmore
   */
  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    return (
      <>
        {hasMore ? (
          <>
            <span>加载中</span>
            <Loading />
          </>
        ) : (
          <span>
            <em className="moreLine">———</em> 仅为您展示最近3个月的碎片明细{' '}
            <em className="moreLine">———</em>
          </span>
        )}
      </>
    );
  };
  useEffect(() => {
    dispatch(
      errorActions.setFragmentEmptyError({
        key: 'emptyFragment',
      }),
    );
    getFragmentAccumulate();
    loadMore();
  }, []);
  return (
    <div className="signin-fragment">
      <LoadingHdl cRef={loadingRef} />
      {data && data.length > 0 ? (
        <>
          <div className="fragment__header">
            <div className="fragment__header__num">
              通过
              <span>
                第{fragmentAccumulate && fragmentAccumulate.periodNo}期
              </span>
              签到您累计获得了
            </div>
            <div className="fragment__header__fragment">
              {fragmentAccumulate && fragmentAccumulate.totalAdd}个碎片
            </div>
          </div>
          {/* 列表 */}
          <div className="fragment__list">
            {data.map((item: any, index: number) => (
              <div className="fragment__item" key={index}>
                <div className="fragment__item__left">
                  <p className="fragment__item__name">{item.reason}</p>
                  <p className="fragment__item__time">{item.createTime}</p>
                </div>
                <div className="fragment__item__right">
                  <span className="fragment__item__num">
                    {item.fragmentCount >= 0 ? '+' : ''}
                    {item.fragmentCount}
                  </span>
                  <img
                    className="fragment__item__icon"
                    src={require('@/images/signInFragment/icon_fragment.png')}
                    alt=""
                  />
                </div>
              </div>
            ))}
          </div>
          {/* 提示文案 */}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} threshold={50}>
            <InfiniteScrollContent hasMore={hasMore} />
          </InfiniteScroll>
        </>
      ) : (
        <Error />
      )}
    </div>
  );
};
export default SignInFragment;
